module.exports = __webpack_public_path__ + "img/support.30f9c13f.png";